export const getActions = () => {
    return {
        actions: [
            {
                label: 'Descargar PDF',
                icon: 'pdf',
                action: 'download'
            },
            {
                label: 'Regenerar',
                icon: 'regenerate',
                action: 'regenerate'
            },
            {
                label: 'Modificar importe',
                icon: 'edit',
                action: 'edit'
            },
            {
                label: 'Eliminar',
                icon: 'delete',
                action: 'remove'
            }
        ],
        extra: []
    };
}